import {
  DMSCustomer,
  DMSDeal,
  DMSTaxGroupDTO,
} from '@upstart/harmony/lib/legos/dmsTypes';
import { Deal } from '@upstart/harmony/lib/legos/dealTypes';
import { DeskingOffer } from '@upstart/harmony/lib/legos/deskingTypes';
import BackendService from '../BackendService';

export type searchCustomerParams = {
  useCoApplicant?: boolean;
  validateCoApplicant?: boolean;
};

export type createCustomerParams = {
  useCoApplicant?: boolean;
};
export default class DMSService {
  static searchCustomer(
    deal: Deal,
    params?: searchCustomerParams,
  ): Promise<DMSCustomer[]> {
    return BackendService.get(`/dms/${deal.id}/customer/search`, { params });
  }

  static createCustomer(
    deal: Deal,
    params?: createCustomerParams,
  ): Promise<DMSCustomer> {
    return BackendService.post(`/dms/${deal.id}/customer`, { params });
  }

  static getTaxGroups(dealerId: string): Promise<DMSTaxGroupDTO> {
    return BackendService.get(`/dms/internal/taxGroups/${dealerId}`);
  }

  static pushToDMS(
    deal: Deal,
    dmsCustomerIds: string[],
    taxGroupId?: string,
  ): Promise<DMSDeal> {
    const params = {
      dmsCustomerIds,
      taxGroupId,
    };
    return BackendService.post(`/dms/${deal.id}/deal`, { params });
  }

  static pushOfferToDMS(
    deskingOffer: DeskingOffer,
    dmsCustomerIds: string[],
    taxGroupId?: string,
  ): Promise<DMSDeal> {
    const params = {
      dmsCustomerIds,
      taxGroupId,
    };
    return BackendService.post(`/dms/${deskingOffer.id}/deskingOffer`, {
      params,
    });
  }

  static async pullFromDMS(deal: Deal, dmsDealId: string): Promise<DMSDeal> {
    const params = {
      dmsDealId,
    };

    return BackendService.get(`/dms/${deal.id}/deal/${dmsDealId}`, { params });
  }
}
